import { useEffect, useState } from "react";
import axios from "axios";
import { Users, UserPlus, UserMinus } from "lucide-react";
import { toast } from "sonner";
import AppLayout, { PageHeader, ComingSoonNote } from "@/components/app/AppLayout";
import { useAuth } from "@/context/AuthContext";
import { fmtNumber } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Communities() {
  const auth = useAuth();
  const [items, setItems] = useState([]);

  const load = () => {
    const params = auth?.user && typeof auth.user === "object" ? `?user_id=${auth.user.id}` : "";
    axios.get(`${API}/communities${params}`).then((r) => setItems(r.data || []));
  };
  useEffect(load, [auth]); // eslint-disable-line

  const toggle = async (c) => {
    if (!auth?.user || typeof auth.user !== "object") { toast.error("Inicia sesión para unirte"); return; }
    try {
      if (c.is_member) {
        await axios.post(`${API}/communities/${c.id}/leave`, {}, { headers: auth.apiHeaders() });
        toast.success(`Saliste de ${c.name}`);
      } else {
        await axios.post(`${API}/communities/${c.id}/join`, {}, { headers: auth.apiHeaders() });
        toast.success(`Te uniste a ${c.name}`);
      }
      load();
    } catch { toast.error("Error"); }
  };

  return (
    <AppLayout hideRightRail>
      <PageHeader kicker="◊ Comunidades" title="Comunidades." subtitle="Grupos por intereses · más vivos que un foro, más íntimos que una red." />

      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="comm-grid">
        {items.length === 0 && <p className="col-span-full text-center text-sm text-ink-mid py-12" data-testid="comm-empty">No hay comunidades.</p>}
        {items.map((c) => (
          <article key={c.id} data-testid={`comm-${c.id}`} className="border hairline bg-cream-card rounded-2xl overflow-hidden">
            <div className="aspect-[3/1] bg-gradient-to-br from-coral/30 to-ink/20 flex items-center justify-center">
              <img src={c.cover} alt="" className="w-16 h-16 opacity-80" />
            </div>
            <div className="p-4">
              <p className="font-mono text-[9px] uppercase tracking-wider text-coral mb-1">{c.category}</p>
              <h3 className="font-serif text-xl tracking-tight">{c.name}</h3>
              <p className="text-xs text-ink-mid mt-0.5 font-mono">{c.handle}</p>
              <p className="text-xs text-ink-mid mt-2 line-clamp-2">{c.description}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-[11px] text-ink-mid inline-flex items-center gap-1"><Users className="w-3 h-3" /> {fmtNumber(c.members)} miembros</span>
                <button
                  onClick={() => toggle(c)}
                  data-testid={`comm-toggle-${c.id}`}
                  className={`text-[11px] px-3 py-1 rounded-full inline-flex items-center gap-1 transition ${c.is_member ? "bg-cream-deep hairline border text-ink-mid" : "bg-coral text-white hover:bg-coral-hover"}`}
                >
                  {c.is_member ? <><UserMinus className="w-3 h-3" /> Salir</> : <><UserPlus className="w-3 h-3" /> Unirme</>}
                </button>
              </div>
            </div>
          </article>
        ))}
      </section>

      <ComingSoonNote feature="creación de comunidades, moderación interna, eventos, salas en vivo" eta="próximas fases" />
    </AppLayout>
  );
}
